<template lang="pug">

  .check-balance-component
    form(@submit.prevent="check", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
      form-group-row(:form="form", name="number", :label="$t('check_balance.number')")
        form-input.playcard-control(:form="form", name="number", :placeholder="$t('check_balance.number_placeholder')" autocomplete="off")
        a.form-link.info(href="#", @click.prevent="showWhatsThisModal = true") {{ $t('check_balance.what_is_this') }}
      form-group-row(:form="form", name="cvv", :label="$t('check_balance.cvv')")
        form-input.cvv-control(:form="form", name="cvv", type="password", :placeholder="$t('check_balance.cvv_placeholder')" autocomplete="off")
        a.form-link.info(href="#", @click.prevent="showWhatsCvvModal = true") {{ $t('check_balance.what_is_this') }}
      .form-group.no-check
        v-button.btn-default(:loading="form.busy", block) {{ $t('check_balance.submit') }}

    modal.card-details-modal(v-if="showCardDetails", @close="showCardDetails = false")
      .v-modal-title Swipe Card Balance
      .v-modal-message.text-left
        .row.justify-content-center
          label.col-md-6.col-10.mb-0 {{ $t('check_balance.play_card_number') }}
          .col-md-6.text-right.col-10.mb-3
            .value {{ cardDetails.barcode }}
        .row.justify-content-center(v-for="(value, key) in cardDetails.balance", :key="key")
          label.col-md-6.col-10.mb-0 {{ $t(`balance.${key}.label`) }}
          .col-md-6.text-right.col-10.mb-3
            .value {{ $t(`balance.${key}.value`, { value }) }}
      .v-modal-buttons
        router-link.btn.btn-primary(:to="{ name: 'playcards.reload', params: { barcode: cardDetails.barcode } }") Reload This Card <br><br>
        .btn.btn-primary(@click="form.reset(); showCardDetails = false; checkAnotherCard = true")
          span Check Balance on Another Swipe Card

    modal.check-another-card-modal(v-if="checkAnotherCard", @close="checkAnotherCard = false")
      form(@submit.prevent="check", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
        .v-modal-title {{ $t('check_balance.title') }}
        .v-modal-message.text-left
          form-group-row(:form="form", name="number", :label="$t('check_balance.number')")
            form-input.playcard-control(:form="form", name="number", :placeholder="$t('check_balance.number_placeholder')" autocomplete="off")
            a.form-link.info(href="#", @click.prevent="showWhatsThisModal = true") {{ $t('check_balance.what_is_this') }}
          form-group-row(:form="form", name="cvv", :label="$t('check_balance.cvv')")
            form-input.cvv-control(:form="form", name="cvv", type="password", :placeholder="$t('check_balance.cvv_placeholder')" autocomplete="off")
            a.form-link.info(href="#", @click.prevent="showWhatsCvvModal = true") {{ $t('check_balance.what_is_this') }}
        .v-modal-buttons
          v-button.btn-default(:loading="form.busy") {{ $t('check_balance.submit') }}

    modal.what-is-number-modal(v-if="showWhatsThisModal", @close="showWhatsThisModal = false")
      .card-number-help

    modal.what-is-cvv-modal(v-if="showWhatsCvvModal", @close="showWhatsCvvModal = false")
      .card-cvv-help

</template>

<script>
import Form from 'vform'

export default {
  name: 'check-balance',

  data: () => ({
    form: new Form({
      number: '',
      cvv: ''
    }),
    showWhatsThisModal: false,
    showWhatsCvvModal: false,
    showCardDetails: false,
    checkAnotherCard: false,
    cardDetails: null
  }),

  methods: {
    async check () {
      const {data} = await this.form.post(`${window.addiesaas.url}/api/playcards/playcard/details`);
      this.cardDetails = data.data;
      this.checkAnotherCard = false;
      this.showCardDetails = true;
    }
  }
}
</script>
